import {Card, Stack} from 'react-bootstrap';
import {AlgoRobotCardComponent} from "./algo-robot-card.component";
import './algo-robots.page.scss.css'
import {DI, LepriconService} from "shared-lib";

const lepriconService = DI.get(LepriconService);
const packageDetails = lepriconService.getAlgoRobotPackageDetails();
export function AlgoRobotsPage(): React.ReactElement {

    return (
        <div>
            <Stack direction="horizontal" className="justify-content-between ">
                <h3 className="mb-4">Algorithmic Trading Bots</h3>
            </Stack>
            <div className='card-container'>
                {
                    packageDetails
                        .map(pkg =>
                            <AlgoRobotCardComponent
                                packageId={pkg.id}
                            />)
                }
            </div>
        </div>
    );
}
